// Importa i componenti migliorati dal file tbl_user_team.js
import { 
    Tbl_user_teamList, 
    Tbl_user_teamEdit, 
    Tbl_user_teamShow, 
    Tbl_user_teamCreate 
} from './tbl_user_team';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: Tbl_user_teamList,
    edit: Tbl_user_teamEdit,
    show: Tbl_user_teamShow,
    create: Tbl_user_teamCreate,
    icon: GroupAddIcon
};
            